import restClient from 'Shared/hooks/restClient'
import { useAct } from 'FlowTaker/store'

const returnToEditorStyles = {
  display: 'flex',
  gap: '30px',
  background: 'black',
  color: 'white',
  width: '100%',
  padding: '15px',
}

const testModeBannerStyles = {
  ...returnToEditorStyles,
  background: 'white',
  color: 'black',
  fontWeight: 'bold',
  textAlign: 'center',
  borderTop: '4px solid orange',
  borderBottom: '4px solid orange',
}

export default function AdminHeader() {
  const act = useAct()

  const flowId = useSel(s => s.taker?.flow?.id)
  const hasEmailToTarget = useSel(s => s.taker.flow.actions.some(a => a.kind === 'email_to_target'))
  const testMode = useSel(s => s.local.testMode)
  const checkAdmin = useSel(s => s.local.checkAdmin)
  const [isAdmin, setIsAdmin] = useState(!!window.ENV.SOFT_LOGIN_USER_ID)
  const urlParams = new URLSearchParams(window.location.search)
  const loadSoftLogin = !isAdmin && (urlParams.has('checkAdmin') || checkAdmin)
  const clientUrl = window.ENV.CLIENT_URL
  const iframeUrl = `${clientUrl}/user/auth/request_soft_login`
  const popupRef = useRef(null)

  const expectedMessageTypes = ['webpackOk', 'webpackStillOk', 'ACTION', 'STATE', 'OPTIONS', 'PARTIAL_STATE', 'START', 'STOP', 'webpackClose', 'webpackInvalid', 'ALPINE_DETECTED', 'webpackWarnings', 'INIT_INSTANCE', 'FLOW_DATA']

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.origin !== clientUrl) return;

      if (event.data.type === 'SOFT_LOGIN_TOKEN') {
        popupRef.current?.close()
        const { data: { success } } = await restClient.post('/api/users/complete_soft_login', { et: event.data.et })
        setIsAdmin(success)
      } else if (event.data.type !== undefined && !expectedMessageTypes.includes(event.data.type)) {
        throw new Error(`Unexpected message type: ${event.data.type}`)
      }
    }
    window.addEventListener('message', handleMessage)

    return () => window.removeEventListener('message', handleMessage)
  }, [])

  useEffect(() => {
    if (urlParams.has('checkAdmin')) {
      const url = new URL(window.location);
      url.searchParams.delete('checkAdmin'); // Remove so not copied into emails etc.
      window.history.replaceState({}, '', url);
      act.local.upsert({ checkAdmin: true }) // Persist over re-renders
    }
  }, [])

  function openSoftLoginPopup() {
    popupRef.current = window.open(
      iframeUrl,
      '_blank',
    )
  }

  function toggleTestMode() {
    act.local.upsert({ testMode: !testMode })
  }

  if (loadSoftLogin) {
    return <div style={returnToEditorStyles}><a onClick={openSoftLoginPopup} style={{ color: 'white', textDecoration: 'underline', cursor: 'pointer' }}>Open Admin Toolbar</a></div>
  }

  if (!isAdmin) return null;

  function makeClientUrl(path) {
    // use URL constructor
    const url = new URL(path, clientUrl);
    return url.toString();
  }

  return <div>
    <div style={returnToEditorStyles}>
      <a href={makeClientUrl(`/admin/flows/${flowId}/build?nav=preview`)} style={{ color: 'white' }}>
        Return to editor
      </a>
      <a href={makeClientUrl(`/admin/flows/${flowId}/overview`)} style={{ color: 'white' }}>
        Return to overview
      </a>
      { (hasEmailToTarget || testMode) && <span style={{ color: 'white', textDecoration: 'underline', cursor: 'pointer' }} onClick={toggleTestMode}>
        { testMode ? 'Disable test mode' : 'Enable test mode' }
      </span> }
    </div>
    { testMode && <div style={testModeBannerStyles}>You're in test mode. Emails to target will go to the sender, not the decision maker.</div> }
  </div>
}
